import { contextFactory } from '@frontend/design-system';

export type CalendarHeaderContextType = {
  calendarTodayDate: string;
  // counts
  calendarEventsCount?: number;
  unconfirmedCalendarEventsCount?: number;
  insuranceAlertCalendarEventsCount?: number;
};

export const [CalendarHeaderContext, useCalendarHeaderContext] = contextFactory<CalendarHeaderContextType>(
  'useCalendarHeaderContext must be used within CalendarHeaderContext'
);
